import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *execute(_this__u8e3s4, $completion) {
  return yield* this.w6w().i6x(_this__u8e3s4, $completion);
}
var GqlTraitClass;
function GqlTrait() {
  if (GqlTraitClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'GqlTrait', VOID, VOID, VOID, [1]);
    GqlTraitClass = $;
  }
  return GqlTraitClass;
}
//region block: exports
export {
  GqlTrait as GqlTrait2wtoeyl3yfalb,
  execute as execute16bhfn490zget,
};
//endregion

//# sourceMappingURL=GqlTrait.mjs.map
